import { useScreenSize } from '../hooks/useScreenSize';
import BibleContent from './BibleContent';
import AppTopBar from './AppTopBar';
import { Head } from '@inertiajs/react'
import { applicationName, colors } from './constants';
import { DesktopSideBar } from './SideBar';
import { useState } from 'react';

export function BibleHeadTags({ title }: { title?: string }) {
  return (
    <Head>
      <title>{title ? `${title} - ${applicationName}` : applicationName}</title>
    </Head>
  )
}

export default function BibleRoute({
  'chosen_book': chosenBook,
  'chosen_translation': chosenTranslation,
  'chosen_chapter': chosenChapter,
  'queried_books': queriedBooks,
  'queried_verses': queriedVerses,
  verses,
  books,
  translations
}: any) {
  const { screenLargerThan } = useScreenSize()
  // Client-side only: seeded from the URL on first load (so a shared/refreshed
  // link still shows its query), then owned entirely by the input. Nothing writes
  // back into it - a late search response must never reset what you typed.
  const [queryInput, setQueryInput] = useState(
    () => new URLSearchParams(window.location.search).get('query') ?? ''
  );
  return (
    <>
      <BibleHeadTags
        title={`${chosenBook.name} ${chosenChapter.chapter_number} (${chosenTranslation.name})`}
      />
      <div style={{
        width: '100%',
        maxWidth: '100%',
        height: '100svh',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        backgroundColor: colors['background'],
      }}>
        <AppTopBar />
        <div style={{
          display: 'flex',
          flexDirection: 'row',
          flex: 1,
          overflow: 'hidden'
        }}>
          {screenLargerThan('lg') && (
            <DesktopSideBar
              chosenTranslation={chosenTranslation}
              queriedBooks={queriedBooks}
              queriedVerses={queriedVerses}
              chosenBook={chosenBook}
              chosenChapter={chosenChapter}
              queryInput={queryInput}
              setQueryInput={setQueryInput}
            />
          )}
          <BibleContent
            verses={verses}
            chosenTranslation={chosenTranslation}
            chosenBook={chosenBook}
            chosenChapter={chosenChapter}
            books={books}
            translations={translations}
            queriedVerses={queriedVerses}
            queriedBooks={queriedBooks}
            queryInput={queryInput}
            setQueryInput={setQueryInput}
          />
        </div>
      </div>
    </>
  )
}